var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGviLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 16,
    viewBox: "0 0 90 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1786_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2823 15.9998H57.5723C55.7608 15.9998 54.5007 15.686 53.7525 15.0978C53.0437 14.4703 52.6499 13.4115 52.6499 11.8429V0.313477H63.2823V3.05857H55.8002V6.74485H61.0376L60.8014 9.48995H55.8002V11.686C55.8002 12.3135 55.9577 12.7448 56.2334 12.9801C56.5091 13.2154 57.0604 13.3331 57.8086 13.3331H63.2823V15.9998Z",
    fill: "url(#paint0_linear_1786_849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.7254V0.274414H5.35555L8.11208 11.5685L10.8686 0.274414H16.2242V15.7254H13.0738V3.76461H12.7194L9.68725 15.0587H6.53692L3.50474 3.76461H3.15032V15.7254H0Z",
    fill: "url(#paint1_linear_1786_849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6108 15.7254V0.274414H22.7612V15.7254H19.6108Z",
    fill: "url(#paint2_linear_1786_849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3769 12.1176C29.8494 12.902 30.6764 13.2941 31.8971 13.2941C33.1179 13.2941 33.9842 12.902 34.4174 12.1176C34.8899 11.3333 35.0868 9.96078 35.0868 8.11765C35.0868 6.23529 34.8506 4.86275 34.4174 4.03922C33.9448 3.13725 33.1179 2.7451 31.8971 2.7451C30.6764 2.7451 29.8494 3.17647 29.3769 4C28.9043 4.86275 28.7074 6.19608 28.7074 8.07843C28.7074 9.96078 28.9043 11.2941 29.3769 12.1176ZM36.8589 14.1176C35.9138 15.3725 34.2205 16.0392 31.8971 16.0392C29.5738 16.0392 27.8805 15.3725 26.896 14.1176C25.9509 12.8235 25.439 10.8235 25.439 8.07843C25.439 5.33333 25.9115 3.33333 26.896 2C27.8805 0.666667 29.5344 0 31.8971 0C34.2599 0 35.9138 0.666667 36.8589 2C37.8434 3.33333 38.3159 5.33333 38.3159 8.07843C38.3159 10.8235 37.8434 12.8235 36.8589 14.1176Z",
    fill: "url(#paint3_linear_1786_849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4971 3.05873V0.274414H50.917V3.05873H46.8216V15.7646H43.6712V3.05873H39.4971Z",
    fill: "url(#paint4_linear_1786_849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2929 15.4902C73.6783 15.8431 72.2213 16 70.9218 16C69.6223 16 68.5984 15.8431 67.8108 15.5294C67.0233 15.2157 66.4326 14.7059 65.9994 14C65.5662 13.2941 65.2512 12.4706 65.0937 11.5294C64.9362 10.5882 64.8574 9.41177 64.8574 8C64.8574 5.01961 65.2906 2.94118 66.1175 1.76471C66.9839 0.588235 68.5197 0 70.8037 0C72.1032 0 73.6389 0.196078 75.3322 0.627451L75.2141 3.09804C73.7177 2.86275 72.4576 2.7451 71.4337 2.7451C70.4492 2.7451 69.7404 2.86275 69.3073 3.13725C68.8741 3.41176 68.5591 3.88235 68.3622 4.62745C68.1653 5.37255 68.0471 6.62745 68.0471 8.43137C68.0471 10.2353 68.244 11.451 68.6772 12.1569C69.1104 12.8235 69.9373 13.1765 71.1974 13.1765C72.4576 13.1765 73.7965 13.0588 75.2141 12.8627L75.2929 15.4902Z",
    fill: "url(#paint5_linear_1786_849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7916 15.7254V9.33324H81.0029V15.7646H77.8525V0.274414H81.0029V6.58814H86.7916V0.274414H89.9419V15.7254H86.7916Z",
    fill: "url(#paint6_linear_1786_849)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1786_849",
    x1: 67.7805,
    y1: 13.8218,
    x2: 47.5538,
    y2: 0.366708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57DEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1786_849",
    x1: 12.9832,
    y1: 34.652,
    x2: 5.11821,
    y2: -8.69488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57DEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1786_849",
    x1: 25.6367,
    y1: 32.3561,
    x2: 17.7717,
    y2: -10.9908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57DEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1786_849",
    x1: 35.9942,
    y1: 30.4769,
    x2: 28.1291,
    y2: -12.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57DEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1786_849",
    x1: 50.0077,
    y1: 27.9341,
    x2: 42.1427,
    y2: -15.4128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57DEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1786_849",
    x1: 73.4131,
    y1: 23.6875,
    x2: 65.5481,
    y2: -19.6594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57DEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1786_849",
    x1: 86.3246,
    y1: 21.3447,
    x2: 78.4596,
    y2: -22.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57DEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEDA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1786_849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.9417,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGviLogo);
export default __webpack_public_path__ + "static/media/gvi-logo.77ed1b82d6062647da03e49e55bf86a5.svg";
export { ForwardRef as ReactComponent };